import { AppRequestsTable } from './components/AppRequestsTable/AppRequestsTable';

export function AppRequestsPage() {
  return (
    <main className="bg-background page-gutter min-h-0 flex-1 overflow-x-hidden py-4 md:py-6">
      <AppRequestsTable />
    </main>
  );
}
